import { PosTransaction } from '../../../models/Pos';
import api from '../api';
import https from 'https';
// import { useState } from 'react';

import { ApiSuccessResponse as ApiResponse } from '../types';
import {
  OrderTransactionDiscountParams,
  PaymentGatewayResponse,
  SpecialOrderParams,
  TableOrderParams,
} from './types';
import { Payment } from '../../../apps/Pos/Sections/OrderModal/PaymentModal/types';
import { useState } from 'react';

// const [terminalId, setTerminalId] = useState<number | null>(null);

let paymentId: number | null = null;
type TableOrderRes = ApiResponse<{ id: string }>;
const tableOrder = async (params: Omit<TableOrderParams, 'type'>) =>
  api.post<TableOrderRes>('/orders', { type: 1, ...params });

type RemoveOrderRes = ApiResponse<{ message: string }>;
const removeOrderItem = async (order_id: string, quantity: number) =>
  api.post<RemoveOrderRes>(`/orders/destroy`, {
    order_id,
    quantity,
  });

type GuestCountRes = ApiResponse<{ message: string }>;
const setGuestCount = (
  table_id: string,
  guest_count: number,
  order_transaction_id: string,
  type: number,
  is_automatic_couvert: boolean,
) =>
  api.post<GuestCountRes>(`/order-transactions/set-guest-count`, {
    guest_count,
    table_id,
    order_transaction_id,
    type,
    is_automatic_couvert,
  });

type PairingRes = ApiResponse<{
  url: string;
  payload: {
    TransactionHandle: {
      SerialNumber: string;
      TransactionDate: string;
      TransactionSequence: number;
      Fingerprint: string;
    };
  };
}>;

const pairTerminal = async (terminal_id: number) => {
  const result = await api.post<PairingRes>('/payments/pavo/rest/pairing', {
    terminal_id,
  });

  const responseData = result.data as unknown as {
    url: string;
    payload: {
      TransactionHandle: {
        SerialNumber: string;
        TransactionDate: string;
        TransactionSequence: number;
        Fingerprint: string;
      };
    };
  };

  if (responseData?.url && responseData?.payload) {
    await api.post(responseData.url, responseData.payload);
  } else {
    throw new Error('Invalid response structure');
  }

  return result; // Return the result directly
};

const setServiceCharge = (
  table_id: string,
  is_automatic_service_charge: boolean,
) =>
  api.post<GuestCountRes>(`/order-transactions/service-charge`, {
    table_id,
    is_automatic_service_charge,
  });

type TableNameRes = ApiResponse<{ message: string }>;
const setTableName = (tableId: string, table_name: string) =>
  api.post<TableNameRes>(`/order-transactions/${tableId}/set-table-name`, {
    table_name,
  });

const setDeliverer = (orderTransactionId: string, delivererId: string) =>
  api.post<TableNameRes>(
    `/order-transactions/${orderTransactionId}/set-deliverer`,
    {
      deliverer_id: delivererId,
    },
  );

type OrderDescriptionRes = ApiResponse<{ message: string }>;
const setOrderDescription = (
  description: string,
  table_id: string,
  order_transaction_id: string,
  type: number,
) =>
  api.post<OrderDescriptionRes>(`/order-transactions/set-description`, {
    description,
    table_id,
    order_transaction_id,
    type,
  });

type OrderCustomerRes = ApiResponse<{ message: string }>;
const setOrderCustomer = (
  table_id: string,
  order_transaction_id: string,
  type: number,
  customer_id?: string,
  customer_address_id?: string,
) =>
  api.post<OrderCustomerRes>(`/order-transactions/set-customer`, {
    table_id,
    order_transaction_id,
    type,
    customer_id,
    customer_address_id,
  });

type OrderDetailsRes = ApiResponse<PosTransaction>;
const getOrderDetails = (tableId: string) =>
  api.get<OrderDetailsRes>(
    `/order-transactions/${tableId}/active-order-transaction`,
  );

const getOrderTransaction = (orderId: string) =>
  api.get<OrderDetailsRes>(`/order-transactions/${orderId}/order-transaction`);

type ChangeTableRes = ApiResponse<{ message: string }>;
const changeTable = (from: string, to: string) =>
  api.post<ChangeTableRes>(`/change-table`, { from, to });

type MoveTableTableRes = ApiResponse<{ message: string }>;
const moveTableOrder = (from: string, to: string) =>
  api.post<MoveTableTableRes>(`/move-table-order`, { from, to });

type SplitTableRes = ApiResponse<{ message: string }>;
const splitTable = (table_id: string) =>
  api.post<SplitTableRes>(`/split-table`, { table_id });

type MergeTablesRes = ApiResponse<{ message: string }>;
const mergeTables = (main_table_id: string, table_ids: string[]) =>
  api.post<MergeTablesRes>(`/merge-tables`, { main_table_id, table_ids });

type SpecialOrderRes = ApiResponse<{ message: string }>;
const addSpecialOrder = (params: SpecialOrderParams) =>
  api.post<SpecialOrderRes>(`/orders/special-order`, params);

type OrderTransactionDiscountRes = ApiResponse<{ message: string }>;
const addOrderTransactionDiscount = (params: OrderTransactionDiscountParams) =>
  api.post<OrderTransactionDiscountRes>(`/order-transaction-discounts`, params);

type CancelTableRes = ApiResponse<{
  tableId: string;
  cancellation_description: string;
  is_excluded_report: Number;
}>;
const cancelTable = (
  tableId: string,
  cancellation_description: string,
  is_excluded_report: Number,
) =>
  api.post<CancelTableRes>(`order-transactions/${tableId}/cancel`, {
    cancellation_description,
    is_excluded_report,
  });

const removeOrderDiscount = async (transactionId: string) =>
  api.delete(`/order-transactions/${transactionId}/remove-discount`);

type OrderTransactionPaymentsRes = ApiResponse<{ message: string }>;
const orderTransactionPayments = (params: Payment) =>
  api.post<OrderTransactionPaymentsRes>(`/order-transaction-payments`, params);

type OrderTransactionPaymentsResKuik = ApiResponse<{
  url: string;
  payload: any;
}>;

const test = async (url, payload) => {
  const res = await fetch(`/api/proxy?url=${encodeURIComponent(url)}`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    throw new Error(`HTTP Error: ${res.status}`);
  }

  const data = await res.json();
};
const orderTransactionPaymentsKuik = async (params: Payment) => {
  try {
    const initialResponse = await api.post<PaymentGatewayResponse>(
      `/payments/pavo/cloud/payments`,
      params,
    );
    paymentId = initialResponse?.data?.payment_gateway_transactions[0]?.id;

    return paymentId;
  } catch (error) {
    console.error('Error in createPayment:', error);
    throw error;
  }
};

const checkPaymentStatus = async () => {
  try {
    const checkResponse = await api.post<PaymentGatewayResponse>(
      `/payments/pavo/cloud/payments/${paymentId}/check`,
    );
    return checkResponse;
  } catch (error) {
    console.error('Error in checkPaymentStatus:', error);
    throw error;
  }
};
const manuelPayment = async () => {
  try {
    const checkResponse = await api.post<PaymentGatewayResponse>(
      `/payments/payment-gateway-transactions/${paymentId}/manuel-approve`,
    );
    return checkResponse;
  } catch (error) {
    console.error('Error in checkPaymentStatus:', error);
    throw error;
  }
};

const cancelPayment = async () => {
  try {
    const checkResponse = await api.delete<PaymentGatewayResponse>(
      `/payments/pavo/cloud/payments/${paymentId}/cancel`,
    );
    return checkResponse;
  } catch (error) {
    console.error('Error in checkPaymentStatus:', error);
    throw error;
  }
};

type OrderTransactionPaymentRemoveRes = ApiResponse<{ message: string }>;
const orderTransactionPaymentRemove = (id: string) =>
  api.delete<OrderTransactionPaymentRemoveRes>(
    `/order-transaction-payments/${id}`,
  );

const getInactiveOrderTransactions = (table_id: string, day_id: string) =>
  api.get('/order-transactions', {
    params: {
      is_active: 0,
      filter: {
        table_id,
        day_id,
      },
      sort: '-ended_at',
    },
  });
const getOpenAccountTransactions = (customer_id: string, page: number) =>
  api.get('/order-transaction-payments', {
    params: {
      filter: {
        customer_id,
      },
      page,
    },
  });

type OrderActiveRes = ApiResponse<{ message: string }>;
const setOrderActive = (orderTransactionId: string) =>
  api.post<OrderActiveRes>(
    `/order-transactions/${orderTransactionId}/set-active`,
  );

type OrderGiftRes = ApiResponse<{ message: string }>;
const setOrderGift = (order_id: string, quantity: number) =>
  api.post<OrderGiftRes>(`/orders/treat`, {
    order_id,
    quantity,
  });

type RemoveOrderGiftRes = ApiResponse<{ message: string }>;
const removeOrderGift = (order_id: string, quantity: number) =>
  api.post<RemoveOrderGiftRes>(`/orders/undo-treat`, {
    order_id,
    quantity,
  });

export default {
  tableOrder,
  setGuestCount,
  setTableName,
  setOrderCustomer,
  setOrderDescription,
  getOrderDetails,
  getOrderTransaction,
  changeTable,
  moveTableOrder,
  splitTable,
  mergeTables,
  removeOrderItem,
  cancelTable,
  addSpecialOrder,
  addOrderTransactionDiscount,
  removeOrderDiscount,
  orderTransactionPayments,
  orderTransactionPaymentRemove,
  getInactiveOrderTransactions,
  getOpenAccountTransactions,
  setOrderActive,
  setDeliverer,
  setOrderGift,
  removeOrderGift,
  setServiceCharge,
  pairTerminal,
  orderTransactionPaymentsKuik,
  checkPaymentStatus,
  manuelPayment,
  cancelPayment,
};
